webpackJsonp([35783957827783],{

/***/ 288:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),s=o(c),f=n(8),d=o(f),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded",throttleDelay:99,debounceDelay:50,disableMutationObserver:!1},j=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,x),(0,b.default)(w,x.once),w},O=function(){w=(0,h.default)(),j()},M=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},S=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},_=function(e){x=i(x,e),w=(0,h.default)();var t=document.all&&!window.atob;return S(x.disable)||t?M():(x.disableMutationObserver||d.default.isSupported()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),x.disableMutationObserver=!0),document.querySelector("body").setAttribute("data-aos-easing",x.easing),document.querySelector("body").setAttribute("data-aos-duration",x.duration),document.querySelector("body").setAttribute("data-aos-delay",x.delay),"DOMContentLoaded"===x.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?j(!0):"load"===x.startEvent?window.addEventListener(x.startEvent,function(){j(!0)}):document.addEventListener(x.startEvent,function(){j(!0)}),window.addEventListener("resize",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("orientationchange",(0,s.default)(j,x.debounceDelay,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,x.once)},x.throttleDelay)),x.disableMutationObserver||d.default.ready("[data-aos]",O),w)};e.exports={init:_,refresh:j,refreshHard:O}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(f,t),M?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return S?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=O();return c(e)?d(e):void(h=setTimeout(f,a(e)))}function d(e){return h=void 0,_&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),o(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,k=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(s);return t=u(t)||0,i(n)&&(M=!!n.leading,S="maxWait"in n,y=S?x(u(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(s);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return f;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?f:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},s="Expected a function",f=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(f,t),M?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return S?x(i,y-o):i}function s(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||S&&o>=y}function f(){var e=j();return s(e)?d(e):void(h=setTimeout(f,u(e)))}function d(e){return h=void 0,_&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=s(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(S)return h=setTimeout(f,t),i(w)}return void 0===h&&(h=setTimeout(f,t)),g}var b,v,y,g,h,w,O=0,M=!1,S=!1,_=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(M=!!n.leading,S="maxWait"in n,y=S?k(a(n.maxWait)||0,t):y,_="trailing"in n?!!n.trailing:_),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==f}function a(e){if("number"==typeof e)return e;if(r(e))return s;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?s:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",s=NaN,f="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e){var t=void 0,o=void 0,i=void 0;for(t=0;t<e.length;t+=1){if(o=e[t],o.dataset&&o.dataset.aos)return!0;if(i=o.children&&n(o.children))return!0}return!1}function o(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}function i(){return!!o()}function r(e,t){var n=window.document,i=o(),r=new i(a);u=t,r.observe(n.documentElement,{childList:!0,subtree:!0,removedNodes:!0})}function a(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),o=Array.prototype.slice.call(e.removedNodes),i=t.concat(o);if(n(i))return u()})}Object.defineProperty(t,"__esModule",{value:!0});var u=function(){};t.default={isSupported:i,ready:r}},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,s=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new s},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){return e=e||document.querySelectorAll("[data-aos]"),Array.prototype.map.call(e,function(e){return{node:e}})};t.default=n}])});

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(34);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 52:
/***/ (function(module, exports) {

	/** @license React v16.8.6
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
	60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
	exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
	exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
	exports.isSuspense=function(a){return t(a)===p};


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(52);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cuadro_icon.0e8dbf49.png";

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAABuCAYAAACgLRjpAAAAAXNSR0IArs4c6QAAF6JJREFUeAHtnQu8XdOdxxOpeAsJIxGPNJUQql5RWoNQBJVMQqLiUZRiUKpenZq2XmVE0WIMig6tmoykRGLQiJuIRz1GPOoRzzwmGoRIgjyIzPd3stfN/6yz9z77nrPPubnnrv/n87trrf/6r/9a57/+Z732Ovt26BCoIgssX758J3Aj6FeRglAoWKASC+BwG4ObwDIg+hxcDbpUoi+UCRbIZAEc7CvgTDAPxNH7ME8Eq2VSGISCBbJaAKfaH7wCfJrpM0i/Bs4GnbLqD3LBArEWwIl6g3uBT2/AGKxChCPALF+A9Htgh1jFgRkskGYBHGddcBlYDCwtJPFT0NmWJ702uARoPWhJ68QbwJpWPsSDBWItgKN0BEeD2cDSlyTuAD1iC0ZM8oeBL4BPc2AMTSsb8tq5BXCQ/uAJ33NIPw12z2oeZKVH028cPQxzu6y6glw7sAAOsQm4FWiUs6RR63jQsaVmoIyOaiaBONI0fS3YsKV6g3wDWQAHWB1otzofWFpC4kqwXjUfl/JrgHEgieaScQoIu+VqDN0Wy9LpBwEdl/h0P4y+eX0mdMnJ7/Er8dLPk947rzqDnlXYAnR0HzDecwAlp4GDa9F09MoJJwJLGmV9GgVji1q0IehsZQvQseuBkcDveE2/54DVa9lE9HcFOju09CiJTy2D+Gfgl2CtWrYn6K6TBehIHascB/4OLGnDcRvYpE5N0YH1NkDniI50XHMI0Mjn0wwYw+vVtlBPDSxAB+4GnvJ7lrSOWvrXoMqyKqlXmw5LL5PQM+a9wFSbEcW1k/5GWcVBYNWxAB3WA9wO/GOV2fCOAS0+Vsnz01H/BGDpJOmHsRqQg35gM4lrpNTTlG55tiPoytkCdFBncD6w0xzJwuO0ywnXzbnKitTRjl5RmwgKpC9G85qP+IZA54Q6L7T0EYnTQTi2qcjyNSxEpwwC/iIf1vKx4Gs1rLoi1bTpGjXO0Lm+IvK2A/5oqSIvgX19+ZBuBQvQEVrYPwh80tWpA1qhSZmqpG0bgQWm0dp0xN4jhD8UvG1kXXQMkV6ZKgxC+VoAw3cBuoW8FFiaR+LH4Ct51oi+tYBGJO1aR4Dvgx+AA4D4Lb7tQpkrgKVBSW1GSE9VLgCf2ALEFwHdwlk7qWzg18ACGPwkYEnXnm4GG+dRHXrk4EdHOuOemJBVRPoiPAu01tw+SxuQ6w3sRul/ypVDvie4E/g0rFzZkJ+jBbC+dcBXSe9UrXp0aBMzBIwGi0E1NI3CcuDUHTf5D5hKtNvtmuVzIPdtMN2UDQ6YxXB5yWB464C3VKMXXeuAs4B2o3mTbkrvn9Q+8jSdWzoySdbnU+geU7DNOmDswtf/sI2YpvM04p3HZ5sOrgabgrxpMxT+hXr0tCNunfgg+ctMpYeYeLuItksHxBn2o3dfBFeAjbyeXu6l80gejhIdE3W3yjp27DiP9BOGt8ru3E0bc43mulvMtWU1UIYD6MD3OnBCjPql8DqDtHXbp+RPBI+D98CHQBdLe4L+YCBIOvDWaPif4EBgaQKJPSNGN9q4JY45wwo0crzdOCAdqwPpMcD/pZqcahbYBiTRW2RcBEbhHHLUWKKONcgYAi4GfWOE5Lg+Pe8xdiTdbhywXUzBOIZ+0/FX4DvfaHh3gSTn+5K8nykfx/tDmvMh04H8JWAUUf3u42zwBRAtAL8AlyrhUZwDeiKNm2z4ERDn05Snkc8e1sohNA0vBuNAHH0M8wgc6qG4zDQeZeR4Oih/gfAqcCi8t+PKwNdOeT55XaJ8jdTthhraAelYrcnuA6ubHn2N+CDwPnjZ8G30cxJDcI7JltnSOOW1XtSUWo7mIOAcMJfD9HIVrir5DTsF43yadjXyWefTjnMPHONNwjOBNgZxdHq1zhenNIU31+T5u3KT1XjRhnRAnE9rsPvBOqbLNJXuj2PpWpOm4zNMno1OQeZmy6hDfFkd6lglq2i4KRjn6oWl/wK6Gotr9zkUx1oU8YYTJo0055ty9YraUdptXOpVd6vW01AjIM6nEe8BsKmx6ovEDzHOp6whJt9Gn0XuScuoU1znk46Wukh7CBvKAemwa4A9UtHOcyBOpR1tgXBSndVpcxJHY+OYdeDpINuRNiTthhrGAXEsjWo/ND33EXGt+fwO7QffjjimSIeHbaIecdqtttidb7s5hJZ9G8IB6US9tep3+kCGTsb54s7e0n5l1hqdv5Vps6IzvXRDJxvCAemhfwN2U/F7nE9POeKoTxwTnnai7yXk1ZKt4yJLL9lEo8cbYRe8AZ001HSURr2kIxaJST6OOsGUPeq9CdjDNEYH4E+bdMNHG2EE3IVesp/jfEa/T1J6LskBVcSOoikq8sli6aB272O0TaXt7qjIsBs3ajuurX7KXqbhzxLX04800kiXRFsnZdSIr/t/Wxjddd8EmbpbJdoIDmgN9zNGkHIXSj+1Bby4HKKedLKpTO2+1aTbRbSRHFCHyBMy9FqaA+qSQl2I6VeH5YeYyibQ/rhduxFpvGgjOeAfM3bPByly+o3v4JT8PLNOQ5ndBN6Yp/K2oqtRHPBLDD4qo9FfLyN3IU6Ytk4sU7x8Nvp3QupcI/ku8aR7iUas8aKN4oBNTF/+E4+k3pqWlBHx5RyXlpGpOBvnW5PCGq3tBYRraH+7uoTgDNhWHdA/SmnJxdFX+fBp60DZ5qc4ynBnpJzDy9G3rdH5MvHfmnS7irZVB+zp9VLmpweMNDrsnWTKKx1Hd+GE/xyXkZVH+eOB3u3XUWUIzyLQRVhHGvVOitrkeO0qtIvgtvTBK3bA6EPqcup3o7imwoVgvSjtAq0D5Tw7E+p4J23z4soUQspohNbjQXfMotduKO9H+mPoPPQ+YdIh2hYsQGc+AhwtIVIYYbK2HXn9IxmVc6TXuekFR0k0n4xfgK+l1UH+ZuCX4GNQjn6fpqtcHsob4tUcbXUEnEoHuUdY0xhFyh0+F/WnRjM68M8wj4gy+hFqF/29KO0H68O4SKCcLrg+B2aCeUA3rzcBe4DtQBa6HaETsggGmVXQAjhB1S8nQkd/YF+P9iHp34Ba01VUUPXaGx0NMQJWbYhV0D8zNYlRUM+N7zLCGsm6g4tBi0ZUoyMtuoDMYdR7NtC5ZSAs0G4dMOr9fyHUBsSRpuDZQC8TKndU48pkCe9EqB+OV+6iRBZdDSXTrh0Qh5hJb7qdqutYPRLbDHwd3OuYFYQaRfV0Q79DPhroaUcgzwLt2gFlCxxD0/B/GLtoR60fN8lphhJqs3M3yHpR9Q1kfw22pvxgEI5ZMEYStdVdcNLnqZR/GgW1LlPoSC//1kioNdvhxHVZdS/QH+hJxlpgDfAxeBPI8SYhW+5RH2KB2rQFcAa7Cx5POpfLA+jx31wPa/lbYN9VyWC0R293fQw4GrYqta/h24LVrQOqE14EuTgJev5VCmPoIXi7trZxaYP+VcTrXvuCA9azYzD+zuBtrxOU1Bvue1XbFnTo5eE6F4yjKTCPBLrVUnOiHv0Pub3BHSCuTXqKs3XNGxIqKLYARl8TaLSK++ctemKhFxBVTJTvDuxhL8ki0uO5u4H+Mc6+YOOKKzMF0aP/nqmLsUeBm8D7II70uO8nwF7rMpraRlQ7vjZNdIA2CiPBCO+DzCJ9LpsCPWKrmND/jxS+DOyZQYk2JDMi6DzxQ/BRhM8JdTSjzY6gdasOv+W42uAo3ArocV7a6Codo8FpfLYPCAOtChbAUfYA/wt8ehTGjtW2ER17A414n4PWIv2H9Z9X+1lC+RpZgM7ReumHwJ+2dNPlRqCRpipCxybgTDARfAbqQZruz6mq4aFw/SxAZ3UB1wB/tJoH7wyQy/knejqBbcERQOeGfwTapMwCS0BWUjv13zN1b9CS/hnhr8A69bNeqCk3C9Bx/cBDwKeXYeyfW0UJiqhjXbAF2AFo564bOLuC3cA3QV+gHbXOGn26B8ZXE1QHdluyAB05GLzp9zBpdXLv1vgs1KuRU//Gy6e/wfhOa7Qp1FlDC9Cp+p+7+rHRQmBpMYm6TXPUtQHQvUN/eaB3V+e2PKihKYPqaixAJ/cAOtS1l1FJFv5b5lGENTmaQq82SHqCo9vYlnLbIFVjl1C2zhbAA3YHT1tPiOKPE+6SZ3PQtyd4LtJvg8kkdsizrqCrDVmAzu8IjgdzgCWNSreAf6jm41B+c6Cfd/o0A0bS70+qqTKUbYsWwBnWB1eCpcCSzt9a/LiLMnpM+HOgg2NLOje8COgqV6BggWIL4Bg6Frkf+PQajAOLpeNTyB0G3gE+6SnKlvGlAjdYwFgARzkYTPM9iPQ40MeINkfhbw8eAT69AGNAs2CIBAtksQBOszo4B2gatqQnHLq4WniTAmFXcD3wn2LMhXcqyOWybJY2B5kGtAAOpGe/twH/2Obv8EYC/46eHFEOqZsugYIF8rEADqVHaE+CNJpIpn5NFyhYIH8L4Fw6tjkGvAssvUPisPxrDBqDBWIsgLPpksHlQI/PdNySdoE0RkNgBQvkYAEcL2wwcrBjUBEsECwQLBAsECwQLBAsECwQLBAsECwQLBAsECwQLBAsECwQLBAsECwQLFAzCyT+AIdTfr1z5Z+A3omyOdBLcPSek6lA/+hlMu8m0XtKMhM6uyA8HOgFj32B3ocyB+iljnqd7ePo1HtTUgk9PRBwj7+ml2sH8qpn3UjpLOS/cBWQJxv0itJfkjfD5WUN0aE3zerH7oV3v6BjmStLnl58XskN6BnoKdgi0n8QepJeuCQ5tfsVynxG2GKiDvXvQHAA2AZ0A5+Ct8BjYAy69e6bEqKsXtSpfz/bUlpYUgBlut92O/B/NgiriHRLeFCJghgGchuBy4De6JRG0jkkRkURC5kmo0Svw00lZP9g5EtuJZP3rMn/RqqymEzK3mDKn2FF4D9o8loSbf49CoW6ZCy4DDn9BmUL24ZyceSPAzNBGunnBFeBwj1IqxOefmRfCel93CsJDduCuB9wS7k+XBzpxzuJr7ogTzr1qoqWkO7fdV7ZsuIYeU2eslOLJYpTyJZzwGOMvluLS6enKLch+CQqr8urRR1Eup4OGDWj8M6aPdNbXvjfdXoVnP3yuPIK/Qu2Lm86kaIrZ6QrdsBmx0GJXlUxBjgDari9HtwLXgFLgKY+vYn0FPBtIDoK3ASeUcISOr9F+n6wYcTXkPunCK8RKt0TDAA/AJIXHQ90EXSQm4YK3OQ/1yI7A1nVVQnpFW5XAv3HI70q43x0zc2o6ETk3LtbbqNc6bSyUtFtRJun/5Xs2NiiWG6HDq/Clx5LHUlsBQ4EGv005d/L59iN9rxJvITIUz/fBwaYzPHEbwGPUU4XbbVs0YxwODgJSK9mkNOBfCCOXoL5ZFxGDG9KgUdFvYCdHseTdk4TU67w7TkWGV1HkuOWEHz90ky3hh09RaRXiWDEIE937Y4H9s0FV8TJI9MEfNIotHOCfOoIqDKUvdAovCBOj89DvhOYEZXTDNE7RsaOgElrOL9YURq9dgoeV5RpEsitA0YBR76jNksjcKcTInwfxPajK0D+FuBpIFsW3QIibUfAq1yZzCEK7gOOxhBZLUth5PQNiSXyrnEKCScDLXLLEnIDgft5pKaBfn4heE3AkTW4LopqBCgieFkcsDtyrt7ZxMu2F5nhwJFmihIis24OqMqpT044PWqUfha6vt8oeAdE+Qrmga/7MnFp5PRz0xLfgFe5A1J4B+BoFhE3ncS1IRMPHb2B28RoKN8sU8FICPnzgKO7/LJkNLlMQhn8UZN+ibh2281EuqwDStiTG9GsICGCvH1T/YA4MWTq6oBqA3VeBxzt5LeLjCkuk1BLqKoIHRU7oLzZGvpS5n5tvaslrUXc+vJ6dP5fCxX+O/IfRmUG8QHXTCm/hDztnKdFMvo2j6ZM2REskrfBtSZxpomXRNHfH+YeUcYLfMZJJUKtx3jPVF007dPuzclz7f4b7b7TyNY9KgccENW6jHB0FK82GGAUaNMRSxgj9uwo+hL8V1RII7Lb8MTqQf4jMg4GH0QC+xHeFMUzB+h5BmG3gNY7/HZLKWwd9DcpcjbreXS+loITrHAVcX05HFlnFG8A0KZFVDK7rGBX9Vfr+LTP+KLVrlGqb8SYQQe4UcfKVBLfNSq0AJ1uZCrSQyNHwlBj90VGOyeftNtzVHJ25zJciI630TWY9CNgLSDd78C/xMlkDDUKfiuSlZMd6ZdDbw9434v47xNm7cg+vi4v3c1LtzhJ23T8Migq+Cqf398Fu/6WyHORXEmAHtng5JKMFYyF6P1RQp42r2kb2KW2nBxQnSXKy/mkS6OpaOGKoPgvH+47cM6NuFqf7cQH0lMESzNNIu0DNYuh46/oOhrG3UCj+8Wk32kWyBYZg9i7QKPzMMrrTfuzvaKnknZT/I3kL/Hyk5JainyZlAl/QUpeahbt3AiBYUBfbH120W9XBEV/7XJmflFOcaI3yWOLWc0pzTRJDqg+n9csWRr5vIhFw7VJEL1VlFFFAl1TCxpXHNO44b5II/kXAh3TbF2UESXgHwccHWZlYDa5DEJ9iYoI3k9Mvt5k8IpJlx1Nkb3AyP/KKoevnaCOLUTSrUdtiUR+3psQbe60c7WwR2hkFejPcY0iR19KRwfFyYiHwFFOKCbUqN9M5Fe1CXFT3VdRtHGz1uoibt2hkSt2i8+ocSF52xNOS6jKrmNeT5CJZaPzajK0kRF1Bv0Ksex/bkZ0cSR+Enaxo8aR8J2dRlHXnOxqc5HUF24DD12MZs0kWpMm7W71UMHRri4SE46Dt62Hls4mMWqLWRqqJ0csjVRHFGdXnLrHlBxq4kVROm9uESNK0OFrED00Sn5K+EYUb0mg9ZuM2GKiXZpi3LpOU5vtTOl1lHXz4eTzCD9DiRzBQksGR/pSnAUWOYYXTiHtlgFHY+vYGYryWr9rDdkMyi31dFWfpAF6VutIB7D6dlVF6NCFBneoqycULT0HPJ8yjjSaFREZTS6TsGQKdsLk6YzQXjRQsS1dflqI3I4SjqiwcyO+j2MQPppW3uUhl/cUPN7pdiF1dAZvAJEO72NnHSM/sSC54s+Jjl8uRFy7W1FuU3ChThTapwl6DJfYqbaRyLnFrmU7nb8j31ETkXVLhGIYyA0Aznm1xipxXnhNwFFqWxHqDmY6YcJMDqimITvZlJPzjTXponVpzEcpsJCvuQNGbdV5qaOmpPZEsns5QcIFwC53EosiVzMH7Ily20kPk05cXJPXEZwK9NRhk7gWw9fo4xpMtPAccfM4WcdD5vtgkYQjusDl2ZC8JidAmOqAKodMpichto6o3KGmHj0HXRalpxN28uXj0sjVxQGj9j4QtU+BLhAkEvn2aYk2NKlfKPI1U84FotxGwELnMc9r6t2f1j4GtObRMcmb8LQY13pOGxWtKTYF+4BTwQ5ANAG5vdDx8Yrkir+k9RxSa0rpXAdowSuddxDqkFmbDx39SOcAcCLYHTjS8UbRDtRl1DEcS10zgZ4v2wX7dbTNHTW1pDl6w9biDAWWon9qBjlf5McwXgKrg19T13j0aM0YR1rLdgVHAi279PRoEuGt4HGg9fnaYEegftQ6WHpFWpcnUQ/07JaU6fG1jl1JFNwF2BssJMvSFUgkjgbkbQ1eLKtlpYBGmWtBms6mleK1GwFlGeo519SlqNa06rBMhKwdAVU+C822yinQxRQqWQN6snI8R5fYPD+OkO4D/rcTzhi+gFwfq4u0PYbJqKYgVnrQDbsruAF8VhBJ/vMUWRopyxJyawEZxp05Eo0l6dylnEJkmkzpwiieVgbZiqZg6aSsLpxqNHd0fVpdfh6F6u2AugY3J2rsYsLefpv8NDIjwLSoTFLg3gTmHlw0q6FAxQ4YuwWXZpRqKv4u2BP0BDoL05mXzpE0tLd4ikCnhnAdfg4EGkXWA5oiHgWT0CndZQk9/RHSGaPoYcotXxGN/4u8doU9otwpyGeZBpuVUX4Iia2A2v8nys9oziwToeyxiBSNGGWKKFtHICOdHDr0JdPSRzSXvFTbI6+B4ZtAtn0C+WcIU4ky8oUBYD+gc9NuYD7QEmQimICeTwhLiLLaKJ5SklGeMfb/AX9VpbZN3YOYAAAAAElFTkSuQmCC"

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/match_icon.bc948ed1.png";

/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ojo_icon.48aeae8a.png";

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ojoscerrados_icon.e40e7520.png";

/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/persona_icon.62736751.png";

/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sonrisa_icon.530aac6d.png";

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _logo_converge_white = __webpack_require__(431);
	
	var _logo_converge_white2 = _interopRequireDefault(_logo_converge_white);
	
	var _persona_icon = __webpack_require__(435);
	
	var _persona_icon2 = _interopRequireDefault(_persona_icon);
	
	var _cuadro_icon = __webpack_require__(430);
	
	var _cuadro_icon2 = _interopRequireDefault(_cuadro_icon);
	
	var _match_icon = __webpack_require__(432);
	
	var _match_icon2 = _interopRequireDefault(_match_icon);
	
	var _ojoscerrados_icon = __webpack_require__(434);
	
	var _ojoscerrados_icon2 = _interopRequireDefault(_ojoscerrados_icon);
	
	var _ojo_icon = __webpack_require__(433);
	
	var _ojo_icon2 = _interopRequireDefault(_ojo_icon);
	
	var _sonrisa_icon = __webpack_require__(436);
	
	var _sonrisa_icon2 = _interopRequireDefault(_sonrisa_icon);
	
	var _aos = __webpack_require__(188);
	
	var _aos2 = _interopRequireDefault(_aos);
	
	__webpack_require__(288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage(props) {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    this.aos = _aos2.default;
	    this.aos.init();
	  };
	
	  IndexPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "header" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-8 col-md-offset-2 centered" },
	              _react2.default.createElement(
	                "h1",
	                null,
	                "Experiencia",
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  { className: "fwextrabold" },
	                  "Globant AI"
	                )
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Powered by ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "fwsemibold" },
	                  "Globant Minds"
	                )
	              ),
	              _react2.default.createElement("img", {
	                src: _logo_converge_white2.default,
	                className: "logoConverge",
	                alt: "Converge"
	              }),
	              _react2.default.createElement(
	                "h6",
	                null,
	                "\xA1Muchas gracias por participar de la ",
	                _react2.default.createElement("br", null),
	                "experiencia ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "fwsemibold" },
	                  "AI"
	                ),
	                " en el marco de la Converge!"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "header__scroll" },
	          _react2.default.createElement("span", null)
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "featured" },
	        _react2.default.createElement(
	          "div",
	          { className: "container mtb" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6", "data-aos": "fade-up" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Reconocimiento Facial ",
	                _react2.default.createElement("br", null),
	                " Similitud Facial"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Registrarse para ingresar o ser atendido en cualquier lugar suele ser una gran incomodidad, sea en edificios, consultas m\xE9dicas, o tr\xE1mites bancarios."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Usando AI, se puede evitar el proceso al reconocer al individuo. Esto se logra porque la AI aprende c\xF3mo comparar la imagen contra registros previos y decidir que son tan similares que representan a la misma persona."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Como parte de la experiencia, analizamos tu rostro y hemos encontrado una celebridad con la cual presentan algun grado de similitud."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-6 centered",
	                "data-aos": "fade-left",
	                "data-aos-delay": "300"
	              },
	              _react2.default.createElement("img", {
	                src: _match_icon2.default,
	                className: "imgMatched img-responsive mt",
	                alt: ""
	              }),
	              _react2.default.createElement(
	                "p",
	                { className: "matchphrase" },
	                "Veo que tienes cierto parecido con",
	                " ",
	                _react2.default.createElement(
	                  "span",
	                  { className: "fwsemibold" },
	                  "Amy Schumer (Actriz)"
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "featured age-detection bluebg" },
	        _react2.default.createElement(
	          "div",
	          { className: "container mtb" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-6 centered",
	                "data-aos": "fade-right",
	                "data-aos-delay": "300"
	              },
	              _react2.default.createElement("img", {
	                src: _persona_icon2.default,
	                className: "imgGeneration img-responsive",
	                alt: ""
	              }),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Tambi\xE9n puedo ver que eres de la:"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "btn btn-conf-2" },
	                "Generaci\xF3n Y"
	              ),
	              _react2.default.createElement(
	                "p",
	                { className: "fwlight" },
	                "(Naciste entre 1982 y 1994)"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6", "data-aos": "fade-down" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Reconocimiento de Edad"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "El reconocimiento facial se puede complementar con un reconocimiento de edad y/o del g\xE9nero de la persona. Durante la experiencia, gracias a AI, hemos detectado tu rango etario y lo hemos traducido a una generaci\xF3n (Millenial, Centennial, etc)."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Dentro de un local comercial, el uso de AI para la idenficaci\xF3n de g\xE9nero y/o rango etario permite conocer qui\xE9nes son los clientes (a\xFAn sin saber identidad) y de esta manera entender a qui\xE9n se le vende y en qu\xE9 momento, lo que permite poder adaptar mejor la oferta."
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "featured" },
	        _react2.default.createElement(
	          "div",
	          { className: "container mtb" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6", "data-aos": "fade-up" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Reconocimiento de Gestos"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Durante la experiencia, te pedimos realizar algunos gestos y los hemos reconocido."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "El reconocimiento de gestos permite (entre otras cosas) saber si realmente la persona identificada est\xE1 all\xED y no sea una foto o video pre-grabado. Esto puede ser usado en casos en los cuales sea necesario dar una prueba de vida, permitiendo realizarla de forma remota y evitando as\xED traslados (especialmente \xFAtil en personas con movilidad reducida)."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Otros usos del reconocimiento de gestos y/o movimientos es que permite detectar, por ejemplo, si un conductor se est\xE1 quedando dormido o est\xE1 ebrio, si est\xE1 sufrieno alg\xFAn ataque cerebral o del coraz\xF3n, y de esta manera poder prevenir un accidente y enviar ayuda en forma inmediata."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "El reconocimiento de gestos no est\xE1 limitado s\xF3lo a los gestos faciales. AI puede ser usado para leer gestos del cuerpo; por ejemplo, se podr\xEDa crear un traductor de lengua de se\xF1as mediante el reconocimiento de los gestos realizados con las manos."
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-6",
	                "data-aos": "fade-left",
	                "data-aos-delay": "300"
	              },
	              _react2.default.createElement(
	                "div",
	                { className: "gestures-box" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "gesture imgEyesClosed" },
	                  _react2.default.createElement("img", { src: _ojoscerrados_icon2.default }),
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Dos ojos cerrados"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "gesture imgSmile" },
	                  _react2.default.createElement("img", { src: _sonrisa_icon2.default }),
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Sonrisa"
	                  )
	                ),
	                _react2.default.createElement(
	                  "div",
	                  { className: "gesture imgEyeWink" },
	                  _react2.default.createElement("img", { src: _ojo_icon2.default }),
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    "Ojo cerrado"
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "featured bluebg" },
	        _react2.default.createElement(
	          "div",
	          { className: "container mtb" },
	          _react2.default.createElement(
	            "div",
	            { className: "row" },
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-md-6 centered",
	                "data-aos": "fade-right",
	                "data-aos-delay": "300"
	              },
	              _react2.default.createElement("img", {
	                src: _cuadro_icon2.default,
	                className: "imgFiltered aligncenter img-responsive mt",
	                alt: ""
	              }),
	              _react2.default.createElement(
	                "p",
	                null,
	                "\xA1Felicitaciones!",
	                _react2.default.createElement("br", null),
	                "Edvard Munch acaba de pintarte un retrato"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "col-md-6", "data-aos": "fade-down" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Transferencia de Estilos"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Durante la experiencia, te demostramos que pudimos aplicar un estilo pict\xF3rico sobre una foto tuya."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "AI puede aprender y aplicar cosas tan complejas como contenido, forma y estilo. Esto no solo de un estilo pict\xF3rico sino tambi\xE9n de estilos de escritura, prosodia y tono de audio, o formalidad de lenguaje."
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                "Un ejemplo de uso es permitir aplicar un estilo de branding sobre todas las im\xE1genes corportativas de una empresa. Otro ejemplo de uso es cambiar los estilos de im\xE1genes para que sean visibles para personas con problemas de daltonismo."
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-da29254c15adb54e11fe.js